import React, { Component } from 'react';
import { connect } from 'react-redux';
import FilterBoxPres from '../presentational/FilterBox';
import { toggleModal, applyDocumentFilters, appliedDocumentFilters } from '../state/documentsActions';
import moment from 'moment';
import { getFiltersCasePhases, resetFiltersCasePhases } from 'src/ui/features/Cases/state/casesActions';
import { onChange, clearFilters } from 'src/ui/features/Cases/state/casesFilterAction';

const mapStateToProps = state => ({
  documents: state.documents.tableData.caseDocuments,
  filters: state.documents.filters,
  showFilterModal: state.documents.showFilterModal,
  anchorModal: state.documents.anchorModal,
  casesFilter: state.casesFilter,
  casePhaseList: state.cases.filters.messages
    ? state.cases.filters.messages.casePhaseList
      ? state.cases.filters.messages.casePhaseList
      : null
    : null,
});

const mapDispatchToProps = {
  openModal: (status, anchorEl) => toggleModal(true, anchorEl),
  closeModal: evt => toggleModal(false),
  applyDocumentFilters: applyDocumentFilters,
  appliedDocumentFilters: appliedDocumentFilters,
  getFiltersCasePhases,
  onChange,
  resetFiltersCasePhases,
  clearFilters,
};

export class FilterBox extends Component {
  constructor(props) {
    super(props);
    this.props.clearFilters();
    this.state = {
      acknowledgedIndex: undefined,
      documentTypeIndex: undefined,
      entityIndex: undefined,
      tagsIndex: undefined,
      employeeIndex: undefined,
      clientIndex: undefined,
      countryIndex: undefined,
      yearIndex: undefined,
      CasePhaseIndex: undefined,
      dateFrom_input: undefined,
      dateTo_input: undefined,
      documentTypeId: undefined,
      acknowledgedId: undefined,
      documentType: undefined,
      entityId: undefined,
      tagId: undefined,
      employeeId: undefined,
      clientId: undefined,
      countryId: undefined,
      yearId: undefined,
      CasePhaseId: undefined,
      caseContactEmailId: undefined,
      addedDocsAfterAllDocsSubmitted: false,
      isLoading: false,
      isLoadingfornonClick: false,
      triggerCloseFilters: undefined,
    };
  }

  async componentDidMount() {
    this.setState({ isLoadingfornonClick: true });
    if(!this.props.isCase) this.props.resetFiltersCasePhases();
    //when filterbox is rendered getdocument api is getting called  //if(this.props.isCase)
    //await this.clearFilters();
    //await this.props.clearFilters();
    this.setState({ isLoadingfornonClick: false });
  }

  setFiltersDivVisibilityState = status => {
    this.setState({ triggerCloseFilters: status });
  };

  onChange = (evt, children) => {
    let name = evt.target.name;
    let value = children[evt.target.value].props.id;
    this.props.onChange({
      [`${name}Index`]: evt.target.value,
      [`${name}Id`]: value,
      filter: true,
    });
    if (evt.target.name === 'documentType') {
      this.setState({
        [`${evt.target.name}Index`]: evt.target.value,
        [`${evt.target.name}`]: children[evt.target.value].props.children,
      });
    }
    this.setState({
      [`${evt.target.name}Index`]: evt.target.value,
      [`${evt.target.name}Id`]: children[evt.target.value].props.id,
    });
    this.populateCasePhase(name, value);
  };

  populateCasePhase = (name, value) => {
    let countryId = '',
      year = '';
    if (name === 'year') {
      year = value;
      countryId = this.props.casesFilter.countryId ? this.props.casesFilter.countryId : '';
    } else if (name === 'country') {
      year = this.props.casesFilter.yearId ? this.props.casesFilter.yearId : '';
      countryId = value;
    }

    if ((name === 'year' || name === 'country') && countryId != '' && year != '') {
      let payload = {
        countryId: countryId,
        yearId: year
      };
      //Hydrate the casePhases as per Country and Year
      this.props.getFiltersCasePhases(payload);
      // To reset the selection in casePhase dropdown
      this.props.onChange({
        ['casePhaseIndex']: undefined,
        [`casePhaseId`]: undefined,
      });
    }
  };

  onChangeDate = (date, name) => {
    const date2 = moment(date).format('DD-MMM-YYYY');
    const withHours = name === 'dateFrom' ? `${date2}T00:00:00Z` : `${date2}T23:59:59Z`;
    this.setState({
      [name]: moment.utc(withHours).format(),
      [name + '_input']: date,
    });
  };

  onTextChange = evt => {
    this.setState({
      [`${evt.target.name}Id`]: evt.target.value !== '' ? evt.target.value : undefined,
      filter: true,
    });
  };

  handlingDocssubmitted(event) {
    if (event.target.checked) {
      this.setState({
        addedDocsAfterAllDocsSubmitted: true,
      });
    } else {
      this.setState({
        addedDocsAfterAllDocsSubmitted: false,
      });
    }
  }

  clearFilters = async name => {
    name === 'click' ? this.setState({ isLoading: true }) : this.setState({ isLoadingfornonClick: true });
    await this.props.clearFilters();
    if(!this.props.isCase) await this.props.resetFiltersCasePhases();
    await this.props.appliedDocumentFilters();
    this.setState({
      dateFrom: moment(Date.now())
        .format('DD-MMM-YYYY')
        .toString(),
      dateTo: moment(Date.now())
        .format('DD-MMM-YYYY')
        .toString(),
      documentTypeIndex: undefined,
      acknowledgedIndex: undefined,
      entityIndex: undefined,
      tagIndex: undefined,
      employeeIndex: undefined,
      clientIndex: undefined,
      countryIndex: undefined,
      yearIndex: undefined,
      CasePhaseIndex: undefined,
      dateFrom_input: undefined,
      dateTo_input: undefined,
      documentTypeId: undefined,
      acknowledgedId: undefined,
      documentType: undefined,
      entityId: undefined,
      tagId: undefined,
      employeeId: undefined,
      clientId: undefined,
      countryId: undefined,
      yearId: undefined,
      CasePhaseId: undefined,
      caseContactEmailId: '',
      addedDocsAfterAllDocsSubmitted: false,
    });

    let data = {
      pageNumber: 1,
      pageSize: this.props.isCase ? 150 : 25,
      sortDirection: 'desc',
      sortColumn: 'dateUploaded',
      filter: true,
      searchText: '',
      caseManagerId: this.props.caseManagerId,
    };
    await this.props.applyDocumentFilters(data);
    name === 'click' ? this.setState({ isLoading: false }) : this.setState({ isLoadingfornonClick: false });
  };

  applyFilters = async evt => {
    this.setState({ isLoading: true });
    const {
      addedDocsAfterAllDocsSubmitted,
      caseContactEmailId,
      CasePhaseId,
      documentTypeId,
      acknowledgedId,
      documentType,
      countryId,
      yearId,
      entityId,
      employeeId,
      clientId,
      tagId,
      dateFrom_input,
      dateTo_input,
    } = this.state;
    let data = {
      uploadedDateFrom: dateFrom_input ? moment(dateFrom_input).format('DD-MMM-YYYY') : undefined,
      uploadedDateTo: dateTo_input ? moment(dateTo_input).format('DD-MMM-YYYY') : undefined,
      documentTypeId,
      documentType,
      countryId,
      yearId,
      CasePhaseId,
      addedDocsAfterAllDocsSubmitted,
      primaryContactEmailID: caseContactEmailId && caseContactEmailId !== '' ? caseContactEmailId : undefined,
      entityId,
      applicantId: employeeId,
      clientId,
      tagId,
      pageNumber: 1,
      pageSize: 25,
      sortDirection: 'desc',
      filter: true,
      acknowledgedId,
    };
    if (this.props.isCase) {
      data = { ...data, caseManagerId: parseInt(this.props.caseManagerId, 10) };
    }
    await this.props.applyDocumentFilters(data);
    this.setState({ isLoading: false });
  };

  render() {
    const { filters, ...otherProps } = this.props;

    return (
      <FilterBoxPres
        {...otherProps}
        clearFilters={this.clearFilters}
        applyFilters={this.applyFilters}
        filters={filters}
        filterIndexes={this.state}
        onChange={this.onChange}
        onChangeDate={this.onChangeDate}
        onTextChange={this.onTextChange}
        handlingDocssubmitted={event => this.handlingDocssubmitted(event)}
        isLoading={this.state.isLoading}
        isLoadingfornonClick={this.state.isLoadingfornonClick}
        triggerCloseFilters={this.state.triggerCloseFilters}
        setFiltersDivVisibilityState={this.setFiltersDivVisibilityState}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterBox);



// WEBPACK FOOTER //
// ./src/ui/features/Documents/containers/FilterBoxContainer.js